import { t } from 'i18next';

import { CourseDurationMinuteEnum } from '@/models/Course';
import { SecondarySelectOption } from '@/components/ui/custom/secondary/SecondarySelect';

export const translateDuration = (minutes: number): string =>
  t(`courseDuration.${minutes}`) || '';

export const courseDurationOptions = (): SecondarySelectOption[] =>
  Object.values(CourseDurationMinuteEnum)
    .filter((value): value is number => typeof value === 'number')
    .map(minutes => ({
      label: translateDuration(minutes),
      value: minutes,
    }));
